<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content">
        <CreateEditContent :id="editId" @confirm="handleConfirm" />
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import CreateEditContent from "../components/CreateEditContent.vue";

export default {
  components: {
    PageHeaderLayout,
    CreateEditContent,
  },
  computed: {
    editId() {
      return this.$route.query.id || "";
    },
  },
  methods: {
    handleConfirm() {
      this.$router.push({ path: "/position" });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-page-content {
  padding: 20px 40px 20px 20px;
}
</style>
